export const headingFontFamily = '"Manrope", "Inter", sans-serif';
